
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';
// import GlobalVariable from '@/globalVariable/globalVariable';

// 必须使用@Component注解
@Component
export default class LoginVue extends Vue {
  private model = new Model();
  private data: any = null;

  private username: string = '';
  private password: string = '';

 

  private created(){
    this.keyupEnter();
  }

  private keyupEnter(){
    document.onkeydown = e =>{
        let body = document.getElementsByTagName('body')[0]
        if (e.keyCode === 13 &&  e.target === body) {
           this.ajaxLogin();
        }
    }
  }

  private async ajaxLogin() {
    if (!this.username) {
      Vue.prototype.$message.info('请填写用户名');
      return ;
    }
    if (!this.password) {
      Vue.prototype.$message.info('请填写密码');
      return ;
    }
    const param = {
      data: {
        username: this.username,
        password: this.password,
      }
    };
    const result = await this.model.ajaxLogin(param);
    if (result) {
      if (result.code == 200) {
        if (this.username === 'wang') {
          // this.GLOBAL.my_managerFlag = true;
          // sessionStorage.setItem('my_managerFlag', 'true'); // 管理员标识设置为true
          localStorage.setItem('my_managerFlag', 'true'); // 管理员标识设置为true
        } else {
          localStorage.setItem('my_managerFlag', 'false');
        }
        //  alert(result.data.id);
        const json = JSON.stringify(result.data);
       
        // sessionStorage.setItem('myuser', json);// 将用户信息缓存
        localStorage.setItem('myuser', json);// 将用户信息缓存
        
        
        // sessionStorage.setItem('sid', this.data.success); // 设置本地存储信息
        // this.$router.push(Vue.prototype.$route.query.redirect);
        // 跳转至前一页，Vue.prototype.$route.query.redirect是获取上面传递过来的值
        this.$router.push({ path: '/fun', query: {} });
      } else {
        Vue.prototype.$message.info('账号或密码错误');
      }
    } else {
      Vue.prototype.$message.info('账号或密码错误');
    }
  }
}
